module.exports = __webpack_public_path__ + "assets/img/H5行情.bc8af3ef.png";